export const macronBallpartner = {
  "id": "macron-ballpartner-2025",
  "title": "Neuer Ballpartner für die Rugby-Bundesliga: Macron liefert offiziellen Spielball",
  "slug": "macron-ballpartner-rugby-bundesliga-spielball",
  "publishedAt": "2025-09-22T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "3 min",
  "tags": ["Rugby", "Bundesliga", "Macron", "Partnerschaft", "Spielball"],
  "excerpt": "Macron wird offizieller Ballpartner der Rugby-Bundesliga und stellt den Spielball für die Saison 2025/26.",
  "img": "/images/macron-ballpartner-2025.png",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Die Rugby-Bundesliga startet nicht nur sportlich spannend in die Saison 2025/26, sondern auch mit einer wichtigen Neuerung: Ab sofort ist Macron offizieller Ballpartner der Rugby-Bundesliga. Der italienische Sportartikelhersteller, der bereits zahlreiche internationale Teams ausstattet, stellt künftig den offiziellen Spielball für alle Partien der Bundesliga."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Der Macron Simoon im Einsatz"
    },
    {
      "type": "paragraph",
      "content": "Zum Einsatz kommt der Macron Simoon, ein moderner Rugbyball, der speziell für den professionellen Spielbetrieb entwickelt wurde. Er zeichnet sich durch hervorragende Griffigkeit, präzise Flugeigenschaften und eine hohe Widerstandsfähigkeit aus. Damit wird er den hohen Anforderungen der Bundesliga gerecht und soll sowohl den Spielern als auch den Zuschauern ein noch besseres Rugby-Erlebnis bieten."
    },
    {
      "type": "paragraph",
      "content": "„Wir freuen uns sehr, mit Macron einen starken Partner an unserer Seite zu haben, der mit seiner Expertise und Qualität perfekt zur Rugby-Bundesliga passt\", heißt es von offizieller Seite des Ligaverbandes. „Der neue Ball wird in allen Spielen der Saison 2025/26 zum Einsatz kommen und ein einheitliches, professionelles Bild schaffen.\""
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Macrons Expansion im deutschen Rugby"
    },
    {
      "type": "paragraph",
      "content": "Macron ist seit Jahren vor allem für seine hochwertige Sportbekleidung bekannt. Mit der Einführung des Macron Simoon als offiziellem Spielball will das Unternehmen nun auch seine Rolle als Ballhersteller ausbauen. Die Zusammenarbeit mit der Rugby-Bundesliga ist dabei ein wichtiger Schritt, um die eigene Präsenz im deutschen Rugby zu stärken und sich langfristig auf dem Markt zu etablieren."
    },
    {
      "type": "paragraph",
      "content": "Mit dem Macron Simoon als offiziellem Spielball setzt die Rugby-Bundesliga künftig auf einheitliche Standards und eine verlässliche Qualität im Spielbetrieb."
    },
    {
      "type": "callout",
      "variant": "info",
      "title": "Professionelle Standards für die Bundesliga",
      "content": "Die Partnerschaft mit Macron unterstreicht das Bestreben der Rugby-Bundesliga, in allen Bereichen professionelle Standards zu setzen und die Qualität des Spielbetriebs kontinuierlich zu verbessern."
    },
    {
      "type": "footer",
      "content": "Artikel-Bild: © Herrmann Agenturfotografie"
    }
  ]
}
